@if (slots) {
  <div class="flex flex-col gap-3 rounded-lg border border-slate-200 bg-white p-3">
    @for (slot of slots; track $index; let i = $index) {
      <app-board-v3-contact-picker
        [slot]="slot"
        [excludeIds]="pickedContactIds"
        [removable]="true"
        (slotChange)="setSlot(i, $event)"
        (remove)="removeSlot(i)"
      />
    }
    <button
      type="button"
      class="flex items-center gap-1 self-start text-xs text-blue-500 hover:text-blue-600"
      (click)="addSlot()"
    >
      <app-icon class="!text-[14px] !h-[14px] !w-[14px] !leading-none">add</app-icon>
      {{ 'board_v3_contact_add_participant' | translate }}
    </button>
    <div class="flex justify-end gap-2 border-t border-slate-100 pt-3">
      <app-button [btnType]="'cancel'" [disabled]="busy" (onChangeClick)="cancelEdit()">
        {{ 'cancel' | translate }}
      </app-button>
      <app-button [disabled]="busy" (onChangeClick)="save()">
        {{ (busy ? 'saving' : 'save') | translate }}
      </app-button>
    </div>
  </div>
} @else if (contacts.length) {
  <div
    class="group relative !flex w-full cursor-pointer !flex-col !items-stretch divide-y divide-slate-200/70 rounded-lg bg-slate-50 px-3 text-left transition hover:bg-slate-100"
    role="button"
    tabindex="0"
    [attr.aria-label]="'board_v3_contact_edit' | translate"
    (click)="startEdit()"
    (keydown.enter)="startEdit()"
  >
    <span
      class="pointer-events-none absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center text-slate-400 opacity-0 transition group-hover:opacity-100"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">edit</app-icon>
    </span>
    @for (contact of contacts; track contact.id) {
      <div class="group/contact flex !w-full min-w-0 items-start gap-3 py-2 pr-8">
        <app-avatar class="mt-0.5" [title]="getContactName(contact)" size="32px" [isPhotoGallery]="false" />
        <div class="flex min-w-0 flex-1 flex-col gap-0.5">
          <button
            type="button"
            class="min-w-0 self-start truncate text-left text-sm font-semibold text-slate-900 hover:text-orange-600"
            (click)="$event.stopPropagation(); openContact(contact)"
          >
            {{ getContactName(contact) }}
          </button>
          @for (phone of getContactPhones(contact); track phone) {
            <a
              class="flex w-fit items-center gap-1 text-xs font-medium !text-slate-600 !no-underline hover:!text-slate-900"
              [href]="phoneHref(phone)"
              (click)="$event.stopPropagation()"
            >
              <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none text-slate-400">phone</app-icon>
              {{ formatContactPhone(phone) }}
            </a>
          }
          @for (email of getContactEmails(contact); track email) {
            <a
              class="flex w-fit items-center gap-1 break-all text-xs font-medium !text-slate-600 !no-underline hover:!text-slate-900"
              [href]="'mailto:' + email"
              (click)="$event.stopPropagation()"
            >
              <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none text-slate-400">mail_outline</app-icon>
              {{ email }}
            </a>
          }
          @for (address of contact.addresses ?? []; track $index) {
            <a
              class="flex w-fit items-start gap-1 break-words text-xs font-medium !text-slate-600 !no-underline hover:!text-slate-900"
              [href]="getAddressMapUrl(address)"
              target="_blank"
              rel="noopener noreferrer"
              (click)="$event.stopPropagation()"
            >
              <app-icon class="!h-3.5 !w-3.5 shrink-0 !text-[14px] !leading-none text-slate-400">location_on</app-icon>
              {{ formatAddress(address) }}
            </a>
          }
        </div>
        <button
          type="button"
          class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded text-slate-400 opacity-0 transition hover:bg-rose-50 hover:text-rose-600 focus:opacity-100 group-hover/contact:opacity-100"
          [matTooltip]="'board_v3_contact_unlink' | translate"
          [disabled]="busy"
          (click)="$event.stopPropagation(); unlink(contact)"
        >
          <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">link_off</app-icon>
        </button>
      </div>
    }
  </div>
} @else {
  <button
    type="button"
    class="flex min-h-16 w-full items-center justify-center gap-1.5 rounded-lg! border border-dashed border-slate-200 text-sm font-medium text-slate-400 transition hover:border-orange-200 hover:bg-orange-50 hover:text-orange-600"
    (click)="startEdit()"
  >
    <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">person_add</app-icon>
    {{ 'board_v3_contact_add' | translate }}
  </button>
}
